import { Plus } from "@/components/ui/icons";
import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuCheckboxItem,
  DropdownMenuContent,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import {
  SIDEBAR_PILL_BUTTON,
  SIDEBAR_PILL_ICON_BUTTON,
} from "./sidebar-section-toggle";

export type HomeSectionFilter = "all" | "recent";

interface HomeSectionPillProps {
  filter: HomeSectionFilter;
  onFilterChange: (value: HomeSectionFilter) => void;
  onCreateClick?: () => void;
}

/**
 * Stripped-down variant of SectionHeaderPill used by the Home scope's
 * Workspaces section (no "Unread" filter — there's no unread-by-
 * workspace concept at the home level).
 */
export function HomeSectionPill({
  filter,
  onFilterChange,
  onCreateClick,
}: HomeSectionPillProps) {
  return (
    <div className="ml-auto flex items-center rounded border border-border/50 overflow-hidden opacity-0 group-hover/section:opacity-100 transition-opacity duration-150">
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" className={SIDEBAR_PILL_BUTTON}>
            {filter === "all" ? "All" : "Recent"}
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent align="end" className="min-w-[100px]">
          {(["recent", "all"] as const).map((value) => (
            <DropdownMenuCheckboxItem
              key={value}
              checked={filter === value}
              onCheckedChange={() => onFilterChange(value)}
              className="text-xs"
            >
              {value.charAt(0).toUpperCase() + value.slice(1)}
            </DropdownMenuCheckboxItem>
          ))}
        </DropdownMenuContent>
      </DropdownMenu>
      {onCreateClick && (
        <>
          <div className="w-px h-3 bg-border/50" />
          <Button
            type="button"
            variant="ghost"
            onClick={onCreateClick}
            className={SIDEBAR_PILL_ICON_BUTTON}
          >
            <Plus size={10} weight="Bold" />
          </Button>
        </>
      )}
    </div>
  );
}
